import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    volume: 100,
    loginShow: false,
    bindShow: '',
    userInfo: {
      id: ''
    },
    payShowType: 0
  },
  getters: {},
  mutations: {
    setVolume(state, volume) {
      state.volume = volume;
    },
    setLoginShow (state, value) {
      state.loginShow = value
    },
    setBindShow (state, value) {
      state.bindShow = value
    },
    setUserInfo (state, value) {
      if (value.user_id) {
        value.id = value.user_id
      }

      state.userInfo = value
      window.localStorage.setItem('userInfo', JSON.stringify(value))
    },
    setPayShowType (state, value) {
      state.payShowType = value
    }
  },
  actions: {},
  modules: {}
});
